module.exports = __webpack_public_path__ + "static/not-good-value.af4d60f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/not-good-value.png
// module id = 1344
// module chunks = 183226617504570